import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import { alpha, styled } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import * as React from 'react';
// import Sitemark from './SitemarkIcon';
import Logo from '../assets/Loopsys.png';
import FormModal from './GetQuoteModal';

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexShrink: 0,
  borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
  backdropFilter: 'blur(1px)',
  border: '1px solid',
  borderColor: (theme.vars || theme).palette.divider,
  backgroundColor: theme.vars
    ? `rgba(${theme.vars.palette.background.defaultChannel} / 0.4)`
    : alpha(theme.palette.background.default, 4),
  // boxShadow: (theme.vars || theme).shadows[1],
  padding: '8px 12px',
}));

export default function AppAppBar() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  const [openModal, setOpenModal] = React.useState(false);

  return (
    <AppBar
      position="fixed"
      enableColorOnDark
      sx={{
        fontFamily: 'Rajdhani',
        boxShadow: 0,
        bgcolor: 'transparent',

        backgroundImage: 'none',
        mt: 'calc(var(--template-frame-height, 0px) + 28px)',
      }}
    >
      <Container sx={{
        width: {
          xs: '95%',
          sm: '100%',
          md: '100%',
          lg: '85%',
          xl: '85%',
        },
      }}>
        <StyledToolbar variant="dense" disableGutters>
          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 0 }}>

            <Link to="/">
              <img src={Logo} alt="Logo" style={{ height: '40px' }} />
            </Link>

            {/* Nav buttons on right */}
            <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
              <Button variant="text" size="large" sx={{ textTransform: 'none', fontFamily: 'Rajdhani', fontWeight: '600' }} component={Link} to="/">
                HOME
              </Button>
              <Button variant="text" size="large" sx={{ textTransform: 'none', fontFamily: 'Rajdhani', fontWeight: '600' }} component={Link} to="/about-us">
                ABOUT US
              </Button>
              <Button variant="text" size="large" sx={{ textTransform: 'none', fontFamily: 'Rajdhani', fontWeight: '600' }} component={Link} to="/services">
                SERVICES
              </Button>
              <Button variant="text" size="large" sx={{ textTransform: 'none', fontFamily: 'Rajdhani', fontWeight: '600' }} component={Link} to="/projects">
                PORTFOLIO
              </Button>
              <Button variant="text" size="large" sx={{ textTransform: 'none', fontFamily: 'Rajdhani', fontWeight: '600' }} component={Link} to="/blogs">
                BLOGS
              </Button>
              <Button variant="text" size="large" sx={{ textTransform: 'none', fontFamily: 'Rajdhani', fontWeight: '600' }} component={Link} to="/journey">
                OUR JOURNEY
              </Button>
              {/* <Button variant="text" sx={{ textTransform: 'none', fontWeight: 700 }} size="small">
                Blogs
              </Button> */}
              <Button variant="text" size="large" sx={{ textTransform: 'none', fontFamily: 'Rajdhani', fontWeight: '600' }} component={Link} to="/contact-us">
                CONTACT US
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: 1,
              alignItems: 'center',
              ml: '12px',
            }}
          >
            {/* <Button color="primary" variant="text" size="small">

            </Button> */}
            <Button color="primary" variant="contained" size="small" onClick={() => setOpenModal(true)}>
              GET QUOTE
            </Button>
            <FormModal open={openModal} onClose={() => setOpenModal(false)} />
            {/* <ColorModeIconDropdown /> */}
          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' }, gap: 1 }}>
            {/* <ColorModeIconDropdown size="medium" /> */}
            <IconButton aria-label="Menu button" onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="top"
              open={open}
              onClose={toggleDrawer(false)}
              PaperProps={{
                sx: {
                  top: 'var(--template-frame-height, 0px)',
                },
              }}
            >
              <Box sx={{ p: 2, backgroundColor: 'background.default' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <IconButton onClick={toggleDrawer(false)}>
                    <CloseRoundedIcon />
                  </IconButton>
                </Box>

                <MenuItem component={Link} to="/" onClick={toggleDrawer(false)}>
                  Home
                </MenuItem>
                <MenuItem component={Link} to="/about-us" onClick={toggleDrawer(false)}>
                  About Us
                </MenuItem>
                <MenuItem component={Link} to="/services" onClick={toggleDrawer(false)}>
                  Services
                </MenuItem>
                <MenuItem component={Link} to="/projects" onClick={toggleDrawer(false)}>
                  Projects
                </MenuItem>
                <MenuItem component={Link} to="/journey" onClick={toggleDrawer(false)}>
                  Our Journey
                </MenuItem>
                {/* Uncomment if needed in the future
<MenuItem component={Link} to="/blogs" onClick={toggleDrawer(false)}>
  Blogs
</MenuItem>
*/}
                <MenuItem component={Link} to="/contact-us" onClick={toggleDrawer(false)}>
                  Contact Us
                </MenuItem>

                <Divider sx={{ my: 3 }} />
                <MenuItem>
                </MenuItem>
                <MenuItem>
                  <Button color="primary" variant="contained" size="small" onClick={() => setOpenModal(true)}>
                    GET QUOTE
                  </Button>
                </MenuItem>
              </Box>
            </Drawer>
          </Box>
        </StyledToolbar>
      </Container>
    </AppBar>
  );
}
